import React from 'react';
import {connect} from 'react-redux';
import {Redirect, withRouter} from 'react-router-dom';
import {Loading} from 'worksource-ui';
import AuthSelectors from 'services/auth/selectors';
import {gql} from 'apollo-boost';
import {useQuery} from '@apollo/react-hooks';

const mapStateToProps = (state) => {
  return {
    currentUser: AuthSelectors.currentUser(state),
    loading: AuthSelectors.isLoading(state),
  };
};

export const requireAuth = (ChildComponent) => {
  const Component = ({location, loading, currentUser}) => {
    const redirect = location.pathname === '/auth/logout' ? '/' : location.pathname;
    if (loading) {
      return <Loading />;
    } else if (currentUser) {
      return <ChildComponent />;
    }

    return <Redirect to={`/auth/login?redirect=${redirect}`} />;
  };

  return withRouter(connect(mapStateToProps)(Component));
};

export const preventAuth = (ChildComponent) => {
  const Component = ({loading, currentUser}) => {
    if (loading) {
      return <Loading />;
    } else if (!currentUser) {
      return <ChildComponent />;
    }

    return <Redirect to="/" />;
  };

  return connect(mapStateToProps)(Component);
};

const FETCH_CURRENT_USER = gql`
  {
    currentUser @client {
      email,
      fullName,
      superuser,
    },
  }
`;

export const useCurrentUser = () => {
  const {data} = useQuery(FETCH_CURRENT_USER);
  return data?.currentUser;
};

